import { render, staticRenderFns } from "./CommentsPanel.vue?vue&type=template&id=1e4d05b6&scoped=true"
import script from "./CommentsPanel.vue?vue&type=script&lang=js"
export * from "./CommentsPanel.vue?vue&type=script&lang=js"
import style0 from "./CommentsPanel.vue?vue&type=style&index=0&id=1e4d05b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4d05b6",
  null
  
)

export default component.exports